// ##############################
// // // Dashboard styles
// #############################

import { successColor } from 'assets/jss/styles.jsx'

const dashboardStyle = {
  successText: {
    color: successColor
  },
  upArrowCardCategory: {
    height: 14,
    width: 14
  }
}

export default dashboardStyle



// WEBPACK FOOTER //
// ./src/assets/jss/dashboard/dashboardStyle.jsx